export const LAUNDRY_GRID_BASE = 'md:sui-grid md:sui-items-start md:sui-items-stretch md:sui-gap-x-4 lg:sui-gap-x-8';

export const LAUNDRY_GRID_COLS = {
  md: {
    4: 'md:sui-grid-cols-4',
    7: 'md:sui-grid-cols-7',
    12: 'md:sui-grid-cols-12'
  },
  lg: {
    2: 'lg:sui-grid-cols-2',
    5: 'lg:sui-grid-cols-5'
  }
};